/**
 * GuideProgress — 셋업 페이지(이름/층/IP/확인) 4단계 + 에디터 가이드 7단계를
 * "N / 11 단계" 하나로 이어 보여주는 공용 진행 표시. 두 페이지가 서로 다른
 * 라우트/컴포넌트라도 이 컴포넌트를 공유해 동일한 스타일로 그린다.
 *
 * 원형 점 11개는 카드 폭(560px)에 다 안 들어가 얇은 세그먼트 바 + 텍스트로
 * 표시한다.
 */
import { FULL_GUIDE_STEP_ORDER, FULL_GUIDE_STEP_LABELS, type FullGuideStep } from '../model/guidedMapStore'
import styles from './GuideProgress.module.css'

interface GuideProgressProps {
  current: FullGuideStep
}

export function GuideProgress({ current }: GuideProgressProps) {
  const idx = FULL_GUIDE_STEP_ORDER.indexOf(current)
  const total = FULL_GUIDE_STEP_ORDER.length

  return (
    <div className={styles.wrap}>
      <div className={styles.segments}>
        {FULL_GUIDE_STEP_ORDER.map((s, i) => (
          <span
            key={s}
            className={i < idx ? styles.segDone : i === idx ? styles.segActive : styles.segTodo}
            title={FULL_GUIDE_STEP_LABELS[s]}
          />
        ))}
      </div>
      <span className={styles.label}>
        {idx + 1} / {total} 단계 · {FULL_GUIDE_STEP_LABELS[current]}
      </span>
    </div>
  )
}
